'use strict';

var DashboardPanelDirective = function DashboardPanelDirective() {
  return {
    restrict: 'E',
    replace: true,
    controller: 'DashboardPanelController',
    template: require('../templates/dashboard-panel.html'),
    scope: {}
  };
};
DashboardPanelDirective.$inject = [];
module.exports = DashboardPanelDirective;